import statement from '@/http/requests/statement'

export default {
  fetchBankAccountList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      statement.bankAccountList(data)
        .then(res => {     
          if (data.page > 1) {
            commit('UPDATE_BANK_ACCOUNT_LIST', res.data.data)
          } else {
            commit('SET_BANK_ACCOUNT_LIST', res.data.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateBankAccount ({ commit }, data) {
    return new Promise((resolve, reject) => {
       statement.updateAccount(data)
        .then(response => {
          commit('UPDATE_BANK_ACCOUNT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addBankAccount ({ commit }, data) {
    return new Promise((resolve, reject) => {
       statement.storeAccount(data)
        .then(response => {
          commit('ADD_BANK_ACCOUNT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
